import React from "react";

const ShowSignature = ({
  showAgreement = false,
  setShowAgreement,
  signatureField,
  title,
  formData
}) => {
  const show = showAgreement;
  const setShow = setShowAgreement;

  const displaySignature = formData[signatureField];

  return (
    <div>
      {show ? (
        <div className="relative">
          <div className="rounded-lg bg-white">
            {/* Signature Label */}
            <label className="block text-base font-medium text-black mb-3">
              {title}
            </label>
            {displaySignature ? (
              <img
                src={displaySignature}
                alt="Signature"
                loading="eager"
                style={{
                  width: "300px",
                  height: "100px",
                  maxWidth: "100%",
                  maxHeight: "100%",
                  borderRadius: "0.375rem",
                  border: "1px solid #D1D5DB",
                  objectFit: "contain",
                  display: "block",
                }}
              />
            ) : (
              <div className="w-full h-24 bg-gray-100 rounded-md border border-gray-300 flex items-center justify-center text-gray-500">
                No signature collected
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="mb-4">
          <label className="inline-flex items-center cursor-pointer">
            <input
              type="radio"
              className="form-radio h-5 w-5 text-indigo-600 border-gray-700 checked:bg-sky-600"
              checked={show}
              onChange={() => setShow(!show)}
            />
            <span className="ml-2 text-base font-medium text-black">I Agree*</span>
          </label>
        </div>
      )}
    </div>
  );
};

export default ShowSignature;
